import React, { createContext, useContext, useCallback } from "react";
import { isEqual, isFunction } from "lodash";

const HistoryUIContext = createContext();

export function useHistoryUIContext() {
  return useContext(HistoryUIContext);
}

export const HistoryUIConsumer = HistoryUIContext.Consumer;

export function HistoryUIProvider({
  historyUIEvents,
  children,
  queryParams,
  setQueryParamsBase,
  ids,
  setIds,
}) {
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    onClickOfViewCommentActionButton:
      historyUIEvents.onClickOfViewCommentActionButton,
    onClickOfUpdateShippingNumberActionButton: 
      historyUIEvents.onClickOfUpdateShippingNumberActionButton,
    onClickOfDownloadVideoActionButton:
      historyUIEvents.onClickOfDownloadVideoActionButton,
    onClickOfDownloadAudioActionButton:
      historyUIEvents.onClickOfDownloadAudioActionButton,
    onClickOfUploadVideoActionButton:
      historyUIEvents.onClickOfUploadVideoActionButton,
    onClickOfUploadAudioActionButton:
      historyUIEvents.onClickOfUploadAudioActionButton,
    onClickOfLinkActionButton: historyUIEvents.onClickOfLinkActionButton,
    onClickOfEmailActionButton: historyUIEvents.onClickOfEmailActionButton,
  };

  return (
    <HistoryUIContext.Provider value={value}>
      {children}
    </HistoryUIContext.Provider>
  );
}
